import { render, staticRenderFns } from "./TableHeadline.vue?vue&type=template&id=31de243a&"
import script from "./TableHeadline.vue?vue&type=script&lang=js&"
export * from "./TableHeadline.vue?vue&type=script&lang=js&"
import style0 from "./TableHeadline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports